import React from 'react';
import { Link } from 'react-router-dom';
import { CountriesActivites } from '../../interface/Back';
import { Activities } from '../../types/Back';

export const Cards = (
  { cca3, name, flags, continents, capital, population, activities, }: 
  CountriesActivites
  // { cca3: string, name: string, flags: string, continents: string, capital: string, population: number, activities: Activities[] }
) => {
  return (
    <div className='cards__container' >
      <h3 className='cards__container__name' >{name}</h3>
      <div className='cards__container__img' >
        <Link to={`/country/${cca3}`} >
          <img src={typeof flags === 'string' ? flags : 'Sin imagen'} alt={name} />
        </Link>
      </div>
      <p className='cards__container__continent' ><b>Contienente: </b>{continents}</p>
      <p><b>Capital: </b>{capital}</p>
      <p><b>Población: </b>{population.toLocaleString()}</p>
      {
        !activities.length ? (
          <p><b>Este país aún no cuenta con actividad(es) 🌎🌏🌍</b></p>
        ) : (
          <section><b>Actividad(es): </b>{
            <div className='cards__container__activities' >
              {activities.map((el: Activities) => {
                return (
                  <ul key={el.id} >
                    <li>{`✔ ${el.name}`}</li>
                  </ul>
                );
              })}
            </div>
          }</section>
        )
      }
    </div>
  )
}
